<div class="api-specification">
  <h2>Variant Colors</h2>
  <table>
    <thead>
      <tr>
        <th>Variant</th>
        <th>Token</th>
        <th>Usage</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Primary filled</td>
        <td><code>--main-primary</code></td>
        <td>Background for <code>mad-primary-button</code> and primary filled Material buttons.</td>
      </tr>
      <tr>
        <td>Primary outlined and text</td>
        <td><code>--main-primary</code></td>
        <td>Label, border, and icon color for primary outline, link, and icon buttons.</td>
      </tr>
      <tr>
        <td>Accent outlined and text</td>
        <td><code>--mat-sys-secondary</code></td>
        <td>Label and border color for accent buttons using <code>color="accent"</code>.</td>
      </tr>
      <tr>
        <td>Danger and warn</td>
        <td><code>--error-color</code></td>
        <td>Background for <code>mad-danger-button</code> and label/border color for <code>color="warn"</code>.</td>
      </tr>
      <tr>
        <td>Disabled opacity</td>
        <td><code>--mad-button-disabled-opacity</code></td>
        <td>Disabled buttons keep their variant color identity and reduce opacity through theme token color mixing.</td>
      </tr>
    </tbody>
  </table>

  <h2>CSS Custom Properties</h2>
  <table>
    <thead>
      <tr>
        <th>Css Custom Property</th>
        <th>Description</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><code>--main-primary</code></td>
        <td>Primary button, outline, text, icon, and group color.</td>
      </tr>
      <tr>
        <td><code>--error-color</code></td>
        <td>Danger button background and warn outline/text color.</td>
      </tr>
      <tr>
        <td><code>--mat-sys-secondary</code></td>
        <td>Accent outline/text color inherited from the active Material 3 theme.</td>
      </tr>
      <tr>
        <td><code>--mad-button-disabled-opacity</code></td>
        <td>Opacity percentage used when mixing disabled button colors.</td>
      </tr>
    </tbody>
  </table>
</div>
